import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getMarketHasAddGuarantorButtonCopy,
  getMarketHasAddress,
  getMarketHasPersonalNumber,
  getMarketsHasAddGuarantorButtonNonFooter,
  getMarketOnlyHasEmailLogin,
  getMarketHasGuarantorSubheader,
  getMarketShouldAskApplicantForFullName,
  getMarketHasRoaring,
  getMarketRequiresPersonalNumberForFetchedOwners,
  getMarketRequiresDateOfBirthForFetchedOwners,
  getMarketRequiresYearOfBirthForFetchedOwners,
  getMarketRequiresCountryOfResidenceForFetchedOwners,
  getMarketHasFetchedOwnershipSharesAsInteger,
  getMarketHasFetchedOwnershipSharesAsRanges,
  getMarketHasMultipleProducts,
  getMarketHasMandatoryTurnover,
  getMarketOnlyAllowsIbanAccountNumbers,
  getMarketHasEskat,
  getMarketHasManualAccountHelperText,
  marketHasTrustpilot,
} from '~/constants/markets';
import { RootState } from '~/store';

const useMarketConfig = () => {
  const { market } = useSelector((state: RootState) => state.intl);

  return useMemo(
    () => ({
      marketHasPersonalNumber: getMarketHasPersonalNumber(market),
      marketHasAddress: getMarketHasAddress(market),
      marketShouldAskApplicantForFullName: getMarketShouldAskApplicantForFullName(
        market
      ),
      marketHasMandatoryTurnover: getMarketHasMandatoryTurnover(market),
      marketsHasAddGuarantorButtonNonFooter: getMarketsHasAddGuarantorButtonNonFooter(
        market
      ),
      marketHasAddGuarantorButtonCopy: getMarketHasAddGuarantorButtonCopy(
        market
      ),
      marketOnlyHasEmailLogin: getMarketOnlyHasEmailLogin(market),
      marketHasGuarantorSubheader: getMarketHasGuarantorSubheader(market),
      marketHasRoaring: getMarketHasRoaring(market),
      marketRequiresPersonalNumberForFetchedOwners: getMarketRequiresPersonalNumberForFetchedOwners(
        market
      ),
      marketRequiresDateOfBirthForFetchedOwners: getMarketRequiresDateOfBirthForFetchedOwners(
        market
      ),
      marketRequiresYearOfBirthForFetchedOwners: getMarketRequiresYearOfBirthForFetchedOwners(
        market
      ),
      marketRequiresCountryOfResidenceForFetchedOwners: getMarketRequiresCountryOfResidenceForFetchedOwners(
        market
      ),
      marketHasFetchedOwnershipSharesAsInteger: getMarketHasFetchedOwnershipSharesAsInteger(
        market
      ),
      marketHasFetchedOwnershipSharesAsRanges: getMarketHasFetchedOwnershipSharesAsRanges(
        market
      ),
      marketHasMultipleProducts: getMarketHasMultipleProducts(market),
      marketHasTrustpilot: marketHasTrustpilot[market],
      marketOnlyAllowsIban: getMarketOnlyAllowsIbanAccountNumbers(market),
      marketHasEskat: getMarketHasEskat(market),
      marketHasManualAccountHelperText: getMarketHasManualAccountHelperText(
        market
      ),
    }),
    [market]
  );
};

export default useMarketConfig;
